module.exports = __webpack_public_path__ + "img/eat.be5030ca.webp";